module.exports = __webpack_public_path__ + "static/img/WRC8LOGO.70df2cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/WRC8/WRC8LOGO.png
// module id = jEZJ
// module chunks = 0